import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik';
import * as Yup from "yup";
import LoadingOverlay from 'react-loading-overlay';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useDispatch } from 'react-redux';
import { handlePostRequest } from '../../services/PostTemplate';
import { handlePutRequest } from '../../services/PutTemplate';
import { useHistory } from "react-router-dom";
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { handleGetRequest } from '../../services/GetTemplate';
import { baseURL } from '../../Config';
import { toast } from 'react-toastify';

const AddEditContact = () => {

    const location = useLocation()
    const { isEditable, rowData } = location?.state;
    const [saveBtnLoading, setSaveBtnLoading] = useState(false)
    const [isActive, setIsActive] = useState(false)
    const [WHStatus, setWHStatus] = useState()
    const [selectedFiles, setSelectedFiles] = useState([])

    const roletypeid = localStorage.getItem("roletypeid")
    const history = useHistory()
    const dispatch = useDispatch()

    const validationSchema = Yup.object().shape({
        companyName: Yup.mixed().required("This field is required."),
        contactNo: Yup.mixed().required("This field is required."),
        address: Yup.mixed().required("This field is required."),
        email: Yup.mixed().required("This field is required."),
        linkedIn: Yup.mixed().required("This field is required."),
        fb: Yup.mixed().required("This field is required."),
        insta: Yup.mixed().required("This field is required."),

    });

    const formik = useFormik({

        validationSchema: validationSchema,
        initialValues: {
            companyName: "",
            contactNo: "",
            address: "",
            email: "",
            linkedIn: "",
            fb: "",
            insta: "",
        },

        onSubmit: async (data) => {

            if (selectedFiles?.length === 0) {
                toast.warn('Please add logo')
            }
            else {

                if (isEditable) {
                    setSaveBtnLoading(true);

                    let obj = {
                        companyName: formik.values.companyName,
                        contactNo: formik.values.contactNo,
                        address: formik.values.address,
                        email: formik.values.email,
                        linkedIn: formik.values.linkedIn,
                        insta: formik.values.insta,
                        fb: formik.values.fb,
                    }

                    const response = await dispatch(handlePutRequest(obj, "/api/Setups/UpdateWarehouse", true, true));
                    if (response?.statusCode == 200) {
                        history.push('./contact')
                        setSaveBtnLoading(false);
                    }
                    setSaveBtnLoading(false);
                }

                else {
                    setSaveBtnLoading(true);

                    let obj = {
                        companyName: formik.values.companyName,
                        contactNo: formik.values.contactNo,
                        address: formik.values.address,
                        email: formik.values.email,
                        linkedIn: formik.values.linkedIn,
                        insta: formik.values.insta,
                        fb: formik.values.fb,
                    }

                    const response = await dispatch(handlePostRequest(obj, "/api/Setups/AddWarehouse", true, true));
                    if (response?.statusCode == 200) {
                        history.push('./contact')
                        setSaveBtnLoading(false);
                    }
                    setSaveBtnLoading(false);
                }
            }
        },
    });


    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    //Get User By Id
    const getWHById = async (rowData) => {
        setIsActive(true)
        const response = await dispatch(handleGetRequest(`/api/Setups/GetWarehouseByid?obj_id=${rowData?.obj_id}`, false));
        const keyData = response[0]
        if (keyData) {
            setWHStatus(keyData?.status)
            formik.setFieldValue('warehouse_id', keyData?.warehouse_id)
            formik.setFieldValue('warehouse_name', keyData?.obj_Name)
            formik.setFieldValue('warehouse_poc', keyData?.warehouse_poc)
            formik.setFieldValue('contact_no', keyData?.contact_no)
            formik.setFieldValue('location', keyData?.location)
            formik.setFieldValue('address', keyData?.address)
            formik.setFieldValue('zip_code', keyData?.zip_code)
            formik.setFieldValue('country_code', keyData?.country_id)

            const selectedFiles = [];

            // Split the keydata.link by commas to get individual entries
            const path = keyData?.logo_img;
            if (path) {
                selectedFiles.push({ fileType: null, fileName: null, base64Data: null, attachment_type: null, path: path });
            }

            setSelectedFiles(selectedFiles);
        }
        setIsActive(false)
    };



    useEffect(() => {
        if (isEditable, rowData) {
            getWHById(rowData);
        }
    }, [isEditable, rowData]);

    return (

        <>
            <LoadingOverlay
                active={isActive}
                spinner
                text='Loading your content...'
                styles={{
                    overlay: (base) => ({
                        ...base,
                        background: 'rgb(38 41 51 / 78%)',
                        width: '107.9%',
                        height: '125%',
                        top: '-27px',
                        left: '-35px'
                    })
                }}
            >

                <div className='main-form-card'>
                    <div className='form-header flex flex-row justify-content-between'>
                        <div className='form-header-content'>
                            <h4 style={{ fontWeight: '600', letterSpacing: '1px', color: 'black' }}>{isEditable ? "Edit" : "Add"} Contact Details</h4>
                            {/* <h6 style={{ color: 'gray' }}> Add Details</h6> */}
                        </div>
                        <div className='mt-4 mr-3'>
                            <Button className='Back-Button mr-3' icon="pi pi-arrow-left" label='Go Back' onClick={() => history.goBack()}>
                            </Button>
                        </div>
                    </div>

                    <div className='form-div'>
                        <form onSubmit={formik.handleSubmit}>

                            <div className="card-form">
                                <div className="card-nested-form">
                                  
                                    <div className="grid mt-2">
                                        <div className="col-12 lg:col-4 md:col-4">
                                            <div className="input-card flex flex-column p-3">
                                                <div className='flex-row'>
                                                    <label> Company Name </label>
                                                    <span className="Label__Required">*</span>
                                                </div>
                                                <InputText className="p-inputtext-sm" maxLength={30} id="companyName" name="companyName" placeholder='Enter company name' value={formik.values.companyName} onChange={formik.handleChange} type="text" />
                                                <span className='ml-2'>
                                                    {getFormErrorMessage("companyName")}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-12 lg:col-4 md:col-4">
                                            <div className="input-card flex flex-column p-3">
                                                <div className='flex-row'>
                                                    <label> Contact No </label>
                                                    <span className="Label__Required">*</span>
                                                </div>
                                                <InputText className="p-inputtext-sm" maxLength={15} minLength={7} keyfilter={/^[0-9.+]+/} id="contactNo" name="contactNo" placeholder='Enter contact No' value={formik.values.contactNo} onChange={formik.handleChange} type="text" />
                                                <span className='ml-2'>
                                                    {getFormErrorMessage("contactNo")}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-12 lg:col-4 md:col-4">
                                            <div className="input-card flex flex-column p-3">
                                                <div className='flex-row'>
                                                    <label> Email </label>
                                                    <span className="Label__Required">*</span>
                                                </div>
                                                <InputText className="p-inputtext-sm" maxLength={30} id="email" name="email" placeholder='Enter email' value={formik.values.email} onChange={formik.handleChange} type="email" />
                                                <span className='ml-2'>
                                                    {getFormErrorMessage("email")}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="grid">
                                        <div className="col-12 lg:col-4 md:col-4">
                                            <div className="input-card flex flex-column p-3">
                                                <div className='flex-row'>
                                                    <label> Address </label>
                                                    <span className="Label__Required">*</span>
                                                </div>
                                                <InputText className="p-inputtext-sm" id="address" name="address" placeholder='Enter Address' value={formik.values.address} onChange={formik.handleChange} type="text" />
                                                <span className='ml-2'>
                                                    {getFormErrorMessage("address")}
                                                </span>
                                            </div>
                                        </div>

                                        <div className="col-12 lg:col-4 md:col-4">
                                            <div className="input-card flex flex-column p-3">
                                                <div className='flex-row'>
                                                    <label> LinkedIn </label>
                                                    <span className="Label__Required">*</span>
                                                </div>
                                                <InputText className="p-inputtext-sm" id="linkedIn" name="linkedIn" placeholder='Enter linkedIn Link' value={formik.values.linkedIn} onChange={formik.handleChange} type="text" />
                                                <span className='ml-2'>
                                                    {getFormErrorMessage("linkedIn")}
                                                </span>
                                            </div>
                                        </div>

                                        <div className="col-12 lg:col-4 md:col-4">
                                            <div className="input-card flex flex-column p-3">
                                                <div className='flex-row'>
                                                    <label> Facebook </label>
                                                    <span className="Label__Required">*</span>
                                                </div>
                                                <InputText className="p-inputtext-sm" id="fb" name="fb" placeholder='Enter facebook link' value={formik.values.fb} onChange={formik.handleChange} type="text" />
                                                <span className='ml-2'>
                                                    {getFormErrorMessage("fb")}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="grid">
                                        <div className="col-12 lg:col-4 md:col-4">
                                            <div className="input-card flex flex-column p-3">
                                                <div className='flex-row'>
                                                    <label> Insta </label>
                                                    <span className="Label__Required">*</span>
                                                </div>
                                                <InputText className="p-inputtext-sm" id="insta" name="insta" placeholder='Enter instagram link' value={formik.values.insta} onChange={formik.handleChange} type="text" />
                                                <span className='ml-2'>
                                                    {getFormErrorMessage("insta")}
                                                </span>
                                            </div>
                                        </div>

                                     
                                    </div>

                                    <div className='col-12 d-flex flex-row text-center mt-4 pb-2'>
                                        {/* <Button className="Cancel-Button" label="Reset" type="button" onClick={ResetForm} /> */}
                                        <Button className="Save-Button ml-2" label={isEditable ? "Update" : "Add"} loading={saveBtnLoading} type="submit" />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </LoadingOverlay>
        </>
    )
}

export default AddEditContact